var map = {
	"./basquet.png": 2546,
	"./default.png": 1750,
	"./futbol.png": 9017,
	"./hockey.png": 9806,
	"./padel.jpg": 5565,
	"./padel.png": 1277,
	"./tenis.png": 9928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1129;